module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"details":"View details"},"et":{"details":"View details"},"ru":{"details":"View details"}}')
  delete Component.options._Ctor
}
